import { createContext, useContext } from "react"

export const PreviewAccountContext = createContext("current-account")
export const usePreviewAccount = () => useContext(PreviewAccountContext)
